export const SETTING_API_01 = "Brands";
export const SETTING_API_02 = "Category";
export const SETTING_API_03 = "Doctype";
export const SETTING_API_04 = "Industry";
export const SETTING_API_05 = "Mou";
export const SETTING_API_06 = "Package";
export const SETTING_API_07 = "Product";
export const SETTING_API_08 = "Subcategory";
export const SETTING_API_09 = "Doccategory";
export const SETTING_API_10 = "Bank";
export const SETTING_API_11 = "Bankbranch";
export const SETTING_API_12 = "Country";
export const SETTING_API_13 = "Taxtype";
export const SETTING_API_14 = "Warehouseparam";
export const SETTING_API_15 = "Warehouse";
export const SETTING_API_16 = "Reasoncategory";
export const SETTING_API_17 = "Reasontype";
export const SETTING_API_19 = "Charges";

// Login API (Post API)
export const LOGIN_API = "Login/Login";
export const LOGOUT_API = "Login/Logout";
export const LOGIN_API_2 = "Login/Transferlogin";
export const UPLOAD_API = "Upload/upload";

//reprot
export const REPORT_API_01 = "Reports";
export const REPORT_API_02 = "Generatereport";

// supplier
export const SUPPLIER_API_01 = "Grnsupplier/Supplier";
export const SUPPLIER_API_02 = "Grnsupplier/Supplierlist";
export const SUPPLIER_API_03 = "Grnsupplier/Supplierdetails";
export const SUPPLIER_API_04 = "Grnsupplier/Supplierproducts";
export const SUPPLIER_API_05 = "Supplieridentitytypes";
export const SUPPLIER_API_06 = "Supplierbranch";
export const SUPPLIER_API_07 = "Supplierbank";
export const SUPPLIER_API_08 = "Suppliermetadata";
export const SUPPLIER_API_09 = "Supplierdocs";
export const SUPPLIER_API_10 = "Suppliercharges";
export const SUPPLIER_API_11 = "Supplierchargetype";

// supplier product
export const SUPPLIER_PRODUCT_API_01 = "Supplierproducts";
export const SUPPLIER_PRODUCT_API_02 = "Supplierproductdoc";
export const SUPPLIER_PRODUCT_API_03 = "Supplierproductdetails";

// GRN
export const GRN_API_01 = "Grn";
export const GRN_API_02 = "Grngridlist";
export const GRN_API_02_2 = "Grngridlistall";
export const GRN_API_02_1 = "Grnlist";
export const GRN_API_03 = "Grnstatus";
export const GRN_API_04 = "Grnlistfilter";
export const GRN_API_05 = "Updategrn";
export const GRN_API_06 = "Updategrnbasic";
export const GRN_API_07 = "Updategrndocs";
export const GRN_API_08 = "Updategrnproduct";
export const GRN_API_09 = "Updategrnproductreturn";
export const GRN_API_09_1 = "Grnproductreturn";
export const GRN_API_10 = "Grnstatustypes";
export const GRN_API_11 = "Grnbulkstatus";
export const GRN_API_12 = "Grntransactionstatustypes";
export const GRN_API_13 = "Grndynamiclist";
export const GRN_API_14 = "Grnreturnlist";
export const GRN_API_15 = "Grnprocess";
export const GRN_API_16 = "Goodsreturnprocess";
export const GRN_API_17 = "Grnreturngridlist";
export const GRN_API_18 = "Grnreturndetail";
export const GRN_API_19 = "Grnreturnbulkstatus";


export const InvCategory_01 = "Invproductcategory";
export const InvSubCategory_01 = "Invproductsubcategory";
export const InvProduct_01 = "Invproduct";